/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import {
  Boton,
  Titulo,
  Formulario,
  accessAPI,
  Sidebar,
  tituloBase,
  TablaFiltrable
} from "../../../../shared";

export default function Evento() {
  const [loader, setLoader] = useState(true);
  const [eventoTipo, setEventoTipo] = useState();
  const [configs, setConfigs] = useState([]);
  const [sideBarNueva, setSideBarNueva] = useState(false);
  const [loaderNueva, setLoaderNueva] = useState(false);
  const [formNuevaKey, setFormNuevaKey] = useState(0);
  const [sideBarEditar, setSideBarEditar] = useState(false);
  const [loaderEditar, setLoaderEditar] = useState(false);
  const [formEditarKey, setFormEditarKey] = useState(0);
  const [selectedConfig, setSelectedConfig] = useState(null);

  const toast = useRef(null);
  const menuRef = useRef(null);
  const { eventoTipoId } = useParams();

  useEffect(() => {
    accessAPI(
      "GET",
      `admin/comunicacion/eventotipos/${eventoTipoId}`,
      null,
      (respuesta) => {
        setEventoTipo(respuesta);
        setConfigs(respuesta.configEvento);
        document.title = respuesta.descripcion;
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar evento",
          sticky: true
        });
        setLoader(false);
      }
    );
    return () => (document.title = tituloBase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function crearConfig(contenidoCampos) {
    setLoaderNueva(true);
    accessAPI(
      "POST",
      `admin/comunicacion/eventotipos/${eventoTipoId}`,
      contenidoCampos,
      (respuesta) => {
        setConfigs((prev) => [...prev, respuesta]);
        setSideBarNueva(false);
        setLoaderNueva(false);
      },
      (respuesta) => {
        setLoaderNueva(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear configuración",
          sticky: true
        });
      }
    );
  }

  function guardarEdicion(contenidoCampos) {
    setLoaderEditar(true);
    accessAPI(
      "PUT",
      `admin/comunicacion/eventoconfig/${selectedConfig.id}`,
      contenidoCampos,
      () => {
        setConfigs((prev) =>
          prev.map((c) =>
            c.id === selectedConfig.id ? { ...c, ...contenidoCampos } : c
          )
        );
        setSideBarEditar(false);
        setLoaderEditar(false);
      },
      (respuesta) => {
        setLoaderEditar(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al guardar",
          sticky: true
        });
      }
    );
  }

  function eliminarConfig() {
    accessAPI(
      "DELETE",
      `admin/comunicacion/eventoconfig/${selectedConfig.id}`,
      null,
      () => {
        setConfigs((prev) => prev.filter((c) => c.id !== selectedConfig.id));
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al eliminar",
          sticky: true
        });
      }
    );
  }

  const menuItems = [
    {
      label: "Editar",
      icon: "pi pi-pencil",
      command: () => {
        setFormEditarKey((k) => k + 1);
        setSideBarEditar(true);
      }
    },
    {
      label: "Eliminar",
      icon: "pi pi-trash",
      command: () => {
        confirmDialog({
          message: `¿Eliminar la comunicación "${selectedConfig?.asunto}"?`,
          header: "Confirmar eliminación",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Eliminar",
          rejectLabel: "Cancelar",
          acceptClassName: "p-button-danger",
          accept: eliminarConfig
        });
      }
    }
  ];

  function copiarCampo(campo) {
    navigator.clipboard.writeText(`[[${campo}]]`);
    toast.current?.show({
      severity: "success",
      summary: "Copiado",
      detail: `[[${campo}]] copiado al portapapeles`,
      life: 2000
    });
  }

  function renderCamposDisponibles() {
    return (
      <div css={{ marginBottom: "1.5em" }}>
        <p css={{ margin: "0 0 0.3em 0", color: "var(--grisTextos)", fontSize: "0.9em" }}>
          Utiliza los campos disponibles en el asunto, texto o destinatario. Click para copiar:
        </p>
        <div css={{ display: "flex", flexWrap: "wrap", gap: "0.4em" }}>
          {eventoTipo.parametros.map((campo) => (
            <span
              key={campo}
              onClick={() => copiarCampo(campo)}
              css={{
                backgroundColor: "var(--surface-100)",
                border: "1px solid var(--surface-300)",
                borderRadius: "4px",
                padding: "0.2em 0.5em",
                fontSize: "0.85em",
                fontFamily: "monospace",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "var(--surface-200)"
                }
              }}
            >
              [[{campo}]]
            </span>
          ))}
        </div>
      </div>
    );
  }

  function getNuevaFormConfig() {
    return {
      secciones: [
        {
          campos: [
            {
              nombre: "asunto",
              tipoitemformularioid: 1,
              etiqueta: "Asunto",
              requerido: true
            },
            {
              nombre: "texto",
              tipoitemformularioid: 11,
              etiqueta: "Texto",
              requerido: true
            },
            {
              nombre: "destinatarioemail",
              tipoitemformularioid: 1,
              etiqueta: "Destinatario email",
              requerido: true
            },
            {
              nombre: "bccemail",
              tipoitemformularioid: 1,
              etiqueta: "Copia oculta (BCC)"
            },
            {
              nombre: "replytoemail",
              tipoitemformularioid: 1,
              etiqueta: "Responder a (Reply-To)"
            }
          ]
        }
      ],
      botones: [
        {
          etiqueta: "Crear comunicación",
          callback: crearConfig,
          validar: true
        }
      ]
    };
  }

  function getEditarFormConfig() {
    if (!selectedConfig) return { secciones: [], botones: [] };
    return {
      secciones: [
        {
          campos: [
            {
              nombre: "asunto",
              tipoitemformularioid: 1,
              etiqueta: "Asunto",
              requerido: true,
              respuesta: selectedConfig.asunto ?? ""
            },
            {
              nombre: "texto",
              tipoitemformularioid: 11,
              etiqueta: "Texto",
              requerido: true,
              respuesta: selectedConfig.texto ?? ""
            },
            {
              nombre: "destinatarioemail",
              tipoitemformularioid: 1,
              etiqueta: "Destinatario email",
              requerido: true,
              respuesta: selectedConfig.destinatarioemail ?? ""
            },
            {
              nombre: "bccemail",
              tipoitemformularioid: 1,
              etiqueta: "Copia oculta (BCC)",
              respuesta: selectedConfig.bccemail ?? ""
            },
            {
              nombre: "replytoemail",
              tipoitemformularioid: 1,
              etiqueta: "Responder a (Reply-To)",
              respuesta: selectedConfig.replytoemail ?? ""
            }
          ]
        }
      ],
      botones: [
        {
          etiqueta: "Guardar cambios",
          callback: guardarEdicion,
          validar: true
        }
      ]
    };
  }

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <ConfirmDialog />
      <Menu model={menuItems} popup ref={menuRef} />

      <Sidebar
        visible={sideBarNueva}
        onHide={() => setSideBarNueva(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nueva comunicación</Titulo>
        {eventoTipo && renderCamposDisponibles()}
        <Formulario
          key={formNuevaKey}
          config={getNuevaFormConfig()}
          loader={loaderNueva}
        />
      </Sidebar>

      <Sidebar
        visible={sideBarEditar}
        onHide={() => setSideBarEditar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Editar comunicación</Titulo>
        {eventoTipo && renderCamposDisponibles()}
        {selectedConfig && (
          <Formulario
            key={formEditarKey}
            config={getEditarFormConfig()}
            loader={loaderEditar}
          />
        )}
      </Sidebar>

      {loader && (
        <div
          css={{
            marginTop: "2em",
            display: "flex",
            flexDirection: "column",
            gap: "1em"
          }}
        >
          <div css={{ display: "flex", alignItems: "center", gap: "1em" }}>
            <Skeleton width="2rem" height="2rem" shape="circle" />
            <Skeleton width="20rem" height="2rem" />
          </div>
          <Card>
            <Skeleton width="100%" height="4rem" css={{ marginBottom: "1em" }} />
            <Skeleton width="100%" height="3rem" />
            {[...Array(3)].map((_, i) => (
              <Skeleton key={i} width="100%" height="3.5rem" css={{ marginTop: "0.3rem" }} />
            ))}
          </Card>
        </div>
      )}

      {!loader && eventoTipo && (
        <div>
          <Titulo urlVolver="/comunicacion/configeventos">
            {eventoTipo.descripcion}
          </Titulo>

          <Card>
            <div css={{ marginBottom: "1em" }}>
              <p css={{ margin: 0 }}>
                <strong>Campos disponibles:</strong>{" "}
                {eventoTipo.parametros.join(", ")}
              </p>
              <p css={{ margin: "0.5em 0 0 0", color: "var(--grisTextos)" }}>
                Los parámetros deben estar rodeados de doble paréntesis recto,
                por ejemplo [[clienteid]].
              </p>
            </div>

            <Titulo
              chico
              botones={
                <Boton
                  texto
                  negro
                  callback={() => {
                    setFormNuevaKey((k) => k + 1);
                    setSideBarNueva(true);
                  }}
                >
                  <i className="pi pi-plus" />
                </Boton>
              }
            >
              Comunicaciones
            </Titulo>
            <TablaFiltrable conFiltros={false}
              value={configs}
              stripedRows
              emptyMessage="No hay comunicaciones configuradas"
              nombreArchivo="comunicaciones_evento"
            >
              <Column header="Asunto" field="asunto" />
              <Column
                header="Destinatario"
                body={(config) => (
                  <div>
                    <div>{config.destinatarioemail}</div>
                    {config.bccemail && (
                      <div css={{ color: "var(--grisTextos)", fontSize: "0.85em" }}>
                        BCC: {config.bccemail}
                      </div>
                    )}
                    {config.replytoemail && (
                      <div css={{ color: "var(--grisTextos)", fontSize: "0.85em" }}>
                        Reply-To: {config.replytoemail}
                      </div>
                    )}
                  </div>
                )}
              />
              <Column
                body={(rowData) => (
                  <Boton
                    texto
                    negro
                    chico
                    callback={(e) => {
                      setSelectedConfig(rowData);
                      menuRef.current.toggle(e);
                    }}
                  >
                    <i className="pi pi-ellipsis-v" />
                  </Boton>
                )}
                style={{ width: "60px", textAlign: "center" }}
              />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
